import api from './api';

export const authService = {
  // Register a new school/teacher
  async register(data) {
    const response = await api.post('/auth/register', {
      school_name: data.schoolName,
      school_email: data.email,
      phone: data.phone,
      location: data.location,
      teacher_name: data.teacherName,
      password: data.password,
    });
    // Normalize response structure
    const result = response.data;
    return {
      user: result.user,
      class_code: result.user?.class_code,
      access_token: result.tokens?.access_token || result.access_token,
      refresh_token: result.tokens?.refresh_token || result.refresh_token,
    };
  },

  // Teacher Login
  async login(email, password) {
    const response = await api.post('/auth/login', {
      email,
      password,
    });
    // Normalize response structure
    const result = response.data;
    return {
      user: result.user,
      access_token: result.tokens?.access_token || result.access_token,
      refresh_token: result.tokens?.refresh_token || result.refresh_token,
    };
  },

  // Student Login (class code + name + PIN)
  async studentLogin(classCode, name, pin) {
    const response = await api.post('/auth/student/login', {
      class_code: classCode,
      name,
      pin,
    });
    // Normalize response structure
    const result = response.data;
    return {
      student: result.student,
      access_token: result.tokens?.access_token || result.access_token,
      refresh_token: result.tokens?.refresh_token || result.refresh_token,
    };
  },

  // Logout (local only - no backend endpoint)
  async logout() {
    // No backend logout endpoint needed - just clear local storage
    return true;
  },

  // Refresh token
  async refreshToken(refreshToken) {
    const response = await api.post('/auth/refresh', {
      refresh_token: refreshToken,
    });
    return response.data;
  },

  // Get current teacher profile
  async getTeacherProfile() {
    const response = await api.get('/auth/teacher/me');
    return response.data;
  },

  // Get current student profile
  async getStudentProfile() {
    const response = await api.get('/auth/student/me');
    return response.data;
  },

  // Get current user profile (legacy - try teacher first, then student)
  async getProfile() {
    try {
      const response = await api.get('/auth/teacher/me');
      return response.data;
    } catch (err) {
      // Try student endpoint
      const response = await api.get('/auth/student/me');
      return response.data;
    }
  },

  // Update profile
  async updateProfile(data) {
    const response = await api.put('/auth/me', data);
    return response.data;
  },

  // Forgot password
  async forgotPassword(email) {
    const response = await api.post('/auth/forgot', { email });
    return response.data;
  },

  // Reset password
  async resetPassword(token, password) {
    const response = await api.post('/auth/reset', { token, password });
    return response.data;
  },

  // Change password
  async changePassword(currentPassword, newPassword) {
    const response = await api.post('/auth/change-password', {
      current_password: currentPassword,
      new_password: newPassword,
    });
    return response.data;
  },
};

export default authService;
